import _ from 'lodash';
import { Icon, Label, Popup } from 'semantic-ui-react';
import { createInitials } from '../../../../global/common/dataAdjust';
import { formatItem, formatTypes } from '../../../../global/common/dateFormatting';
import { matchCalcs } from '../../helpers/match';
import { _matchLsTypes } from '../../cnr/reducers/SportsDataReducer';
import { gEnums } from '../../../../global/enums/globalEnums';
import { getSectionColor } from '../../create/sectionColors';
import { _matchDisplayTypes } from './MatchContent';
import { _matchResultSourceTypes, useMatchResults } from 'projectSpecific/sports/useHelpers/useMatchResults';
import DragWrapper from 'global/dragNDrops/DragWrapper';

const _circular = false

const MatchDivs = ({
  _teamKey,
  allowEdits,
  handleShow_matchOptions,
  match: match_current,
  matchDisplayType,
  matchScheduleDisplayType,
  mdps,
  matchUrl,
  matchProps,
  rtm
}) => {

  const { home, away, _status, ls, poolKey, isConsolation, matchNumber, isPlayoff } = match_current ?? {}
  const { isBye, isPendingish } = _status ?? {}

  const _umr = useMatchResults({ match_true: match_current })
  const { results_match, result_source } = _umr

  // if (result_source === _matchResultSourceTypes.realtime) {
  //   console.log('results_match', results_match)
  // }

  const openMatchUrl = (e) => {
    e.stopPropagation()
    window.open(matchUrl, '_blank')
  }

  const trimText = (text, maxLength) => {
    if (!_.isString(text)) return text;
    return text.length > maxLength ? text.slice(0, maxLength) + '...' : text;
  };
  const videoIcon = () => <Icon color={'blue'} name={'video'} size='small' onClick={(e) => { openMatchUrl(e) }} />
  const homeIcon = (locationNotConfirmed) => <Icon color={locationNotConfirmed ? 'yellow' : 'green'} name={'map marker alternate'} />
  const locationIcon = (home) => <Icon size='small' color={home?.id === _teamKey ? 'teal' : 'orange'} name={home?.id === _teamKey ? 'home' : 'bus'} />
  const trophyIcon = (isPlayoff) => isPlayoff && <Icon color={'blue'} name={'trophy'} />
  const dotIcon = (lsProps) => <Icon color={lsProps.lsColor} name={lsProps.lsIcon} />

  const slIcon = (lsProps, isPlayoff) => {
    if (isPlayoff) {
      return trophyIcon(isPlayoff)
    } else {
      return dotIcon(lsProps)
    }
  }

  const getLsProps = () => {

    let _ls = ls

    if (isPlayoff) {
      _ls = poolKey ? _.startCase(poolKey) : 'Playoffs'
      if (isConsolation) {
        _ls = _ls.replace('Finals', 'Consolation')
      } else if (isPlayoff) {
        if (poolKey !== 'finals' && matchNumber) {
          _ls += ' - #' + matchNumber
        }
      }
    }

    let _lsColor = 'black';
    let _lsIcon = 'circle thin'

    switch (match_current._matchCollectionKey) {
      case _matchLsTypes.exhibition:
        _lsColor = 'orange'
        break;
      case _matchLsTypes.tournament:
        _lsColor = 'purple'
        _ls = 'Tournament'
        break;
      case _matchLsTypes.nonDistrict:
        _lsColor = 'grey'
        _lsIcon = 'circle outline'
        break;
      default:
        if (matchCalcs.isNon(match_current._matchCollectionKey) || matchCalcs.isNon(match_current.sections)) {
          _lsColor = 'green'
          _lsIcon = 'circle outline'
        } else {
          _lsColor = isPlayoff ? 'blue' : 'green'
        }
    }

    if (isPlayoff) {
      _lsIcon = 'trophy'
      _lsColor = 'grey'
    }

    return { _ls, lsColor: _lsColor, lsIcon: _lsIcon }

  }

  const locationPlayoffText = (isBye, locationName, homeName) => {
    let locationText = ''
    let locationNotConfirmed = false
    if (isBye) {
      locationText = ' '
    } else {
      if (!locationName) {
        locationText = homeName && homeName.indexOf('/') < 0 ? homeName : 'TBD'
        locationNotConfirmed = true
      } else {
        locationText = locationName
      }
    }
    return { locationText, locationNotConfirmed }
  }

  return matchProps && _.map(matchProps, (propKey, index) => {

    if (!propKey) return;

    if (Array.isArray(propKey)) {
      // Combine the values with a hyphen between them and wrap in a div with class from the first part of the array

      const className = propKey[0].split('.')[0]; // Get the first part of the property (before the dot)

      let combinedValues = propKey.map((key) => _.get(match_current, key, '')).join(' - ');

      if (results_match) {
        combinedValues = propKey.map((key) => _.get(results_match, key, '')).join(' - ');
      }

      let oc = null;

      return (
        <div key={index} className={className} onClick={(e) => { oc && oc(e, match_current) }}>
          {combinedValues}
        </div>
      );
    } else {

      // Handle single property
      let className = `match-${propKey.replace(/\./g, '-')}`;
      let value = _.get(match_current, propKey, '');
      let valuePending = _.get(match_current, 'pending')
      let title = value;
      let icon;
      let oc = null;
      let allowDrag = false;
      let dragValue;

      className = className.replace('_', '')

      switch (propKey) {
        case 'pending.away.seed':
          if (!value) { value = valuePending?.away?.originalSeed }
          value = <Label circular={_circular} size='mini' color={'grey'}>{value ? value : '-'}</Label>
          break;

        case 'pending.home.seed':
          if (!value) { value = valuePending?.home?.originalSeed }
          value = <Label circular={_circular} size='mini' color={'grey'}>{value ? value : '-'}</Label>
          break;

        case 'pending.away.originalSeed':
        case 'pending.home.originalSeed':
          value = <Label circular={_circular} size='mini' color={'grey'}>{value ? value : '-'}</Label>
          break;

        case 'pending.away.matchNumber':
          const _poolNameA = _.get(match_current, 'pending.away.poolName', '');
          value = `Winner ${_poolNameA}/#${value}`
          break;

        case 'pending.home.matchNumber':
          const _poolNameH = _.get(match_current, 'pending.home.poolName', '');
          value = `Winner ${_poolNameH}/#${value}`
          break;

        case 'away.seed':
          if (!value) { value = valuePending?.away?.originalSeed }
          value = <Label style={{ border: `1px solid var(--sem-${getSectionColor(away?.sections)})` }} circular={_circular} size='mini'>{value ? value : '-'}</Label>
          break;

        case 'home.seed':
          if (!value) { value = valuePending?.home?.originalSeed }
          value = <Label style={{ border: `1px solid var(--sem-${getSectionColor(home?.sections)})` }} circular={_circular} size='mini'>{value ? value : '-'}</Label>
          break;

        case 'matchNumber':
          if (isPendingish) {
            value = 'pending'
          } else {
            value = <Label size='mini' color='grey'>{value ? value : '-'}</Label>
          }
          break;

        case 'startDate':
          switch (matchScheduleDisplayType) {
            case gEnums.matchScheduleDisplayTypes.teamSchedule:
              icon = locationIcon(home)
              break;
            default:
          }
          switch (matchScheduleDisplayType) {
            case gEnums.matchScheduleDisplayTypes.levelOverviewMatches:
              value = formatItem(formatTypes.dateDayMonth, value)
              break;
            default:
              // value = formatItem(formatTypes.shortDate, value)
              value = value ? formatItem(formatTypes.dateDayMonth, value) : 'TBD'
          }
          break;

        case 'ls':
          icon = slIcon(getLsProps())
          if (isConsolation) {
            value = value.replace('Finals', 'Consolation')
          }
          break;

        case 'location.name':
          const { locationText, locationNotConfirmed } = locationPlayoffText(isBye, value, home?.name)
          value = locationText || 'TBD'
          icon = homeIcon(locationNotConfirmed)
          oc = allowEdits ? handleShow_matchOptions : null
          allowDrag = true
          dragValue = value
          value = createInitials(value, 4)
          break;

        case 'home.name':
        case 'away.name':
        case 'opponent.name':
          switch (propKey) {
            case 'home.name':
              if (home?.levels === _matchLsTypes.Non) {
                className += ' nd'
              }
              break;
            case 'away.name':
              if (away?.levels === _matchLsTypes.Non) {
                className += ' nd'
              }
              break;
            default:
            // nothing
          }

          switch (matchDisplayType) {
            case _matchDisplayTypes.levelOverviewMatches:
              // value = createInitials(value)
              value = trimText(value, '20')
              break;
            default:
              value = trimText(value, '20')
            // nothing
          }
          break;

        case 'startTime':
          if (isBye) {
            value = '---'
          }
          oc = allowEdits ? handleShow_matchOptions : null
          value = value ? value : 'TBD'
          // if (rtm?.results?.scores) {
          //   const { scores, setNumber } = rtm.results
          //   const score = scores?.[setNumber]
          //   const { away, home } = score
          //   const colors = {
          //     home: home > away ? 'green' : 'red',
          //     away: away > home ? 'green' : 'red',
          //   }
          //   value = <div style={{ display: 'flex' }}><Label size='tiny' color={colors.away}>{away}</Label><Label size='tiny'>{setNumber}</Label><Label size='tiny' color={colors.home}>{home}</Label></div>
          //   console.log('rtm', rtm)
          // }
          break;
        case 'videoUrl':
          icon = videoIcon()
          break;
        default:
        // value = propKey
        // noting
      }

      // className += ' ' + result_source

      if (allowDrag) {
        return (
          <DragWrapper
            dragData={{ value: dragValue, match: match_current }}
            key={index}
            className={className}
            title={title}
            icon={icon}
            value={value}
          >
          </DragWrapper>
        );
      } else {
        return (
          <div
            key={index}
            className={className}
            // title={title}
            onClick={(e) => { oc && oc(e, match_current, propKey) }}
          >
            {icon}
            {value}
          </div>
        );
      }
    }
  });
};

export default MatchDivs